// extracted by mini-css-extract-plugin
export default {"Container":"SearchBar_Container__GVuRQ","inputContainer":"SearchBar_inputContainer__-1Fas","icon":"SearchBar_icon__j+7ER","inputField":"SearchBar_inputField__StZGi"};